<template>
  <div class="modal-inbox-members">
    <div class="modal-header">
      <h2>Izaberite člana</h2>
    </div>
    <div class="input-wrapper">
      <input
        placeholder="Pretraga članova"
        class="form-control form-control-lg"
        id="input-search-members"
        type="text"
        v-model="searchCriteria"
      />
    </div>
    <div class="members-wrappers">
      <basic-info
        class="modal-member"
        @click.native="makeFictiveChat(m)"
        v-for="m in filteredList"
        :key="m.id"
        :name="m.user_full_name"
        :description="m.communityName + ' | ' + (m.div_desc ? m.div_desc : '')"
        :profilePictureURL="baseURL + m.profile_pic_URL.link"
      />
    </div>
    <div class="modal-footer">
      <button class="btn btn-danger" @click="closeModal">Zatvori</button>
    </div>
  </div>
</template>

<script>
import { mapMutations } from 'vuex';
import axios from '@/axios/axios.js';
import basicInfo from '@/components/common/BasicInfo.vue';

export default {
  components: {
    basicInfo
  },
  computed: {
    filteredList() {
      if (this.searchCriteria === '') {
        return this.members;
      } else {
        return this.members.filter(member => {
          if (
            member.user_full_name
              .toLowerCase()
              .includes(this.searchCriteria.toLowerCase()) ||
            member.communityName
              .toLowerCase()
              .includes(this.searchCriteria.toLowerCase()) ||
            member.div_desc
              .toLowerCase()
              .includes(this.searchCriteria.toLowerCase())
          ) {
            return member;
          }
        });
      }
    }
  },
  created() {
    for (let c of this.$store.state.communities.communities) {
      axios
        .post('member/get-members-by-community', {
          community_id: c.community_id,
          active: 1
        })
        .then(({ data }) => {
          data = data.filter(member => member.id !== c.member_id);

          this.members.push(
            ...data.map(member => {
              return {
                ...member,
                communityName: c.address + ' ' + c.street_number
              };
            })
          );
        })
        .catch(err => {
          console.log(err);
        });
    }
  },
  methods: {
    ...mapMutations('modal', ['closeModal']),
    makeFictiveChat(member) {
      this.$store.commit('setFictiveChat', member);
      this.closeModal();
    }
  },
  data() {
    return {
      members: [],
      baseURL: process.env.VUE_APP_OBJECT_STORAGE_URL,
      searchCriteria: ''
    };
  }
};
</script>

<style scoped lang="scss">
.modal-inbox-members {
  // min-height: 640px;
  height: 80vh;
  position: relative;
  display: flex;
  flex-direction: column;

  #input-search-members {
    width: 100%;
    height: 70px;
    border: none;
    border-radius: 0;
    margin-bottom: 10px;
    border-bottom: 2px solid transparent;
    transition: 0.5s border-bottom;
    background-color: #eeeeee;
  }

  #input-search-members:focus {
    box-shadow: none;
    border-bottom: 2px solid var(--primary-color);
  }

  .members-wrappers {
    padding: 5px;
    // max-height: 400px;
    overflow-y: auto;
    margin-bottom: 64px;

    .modal-member {
      padding: 5px;
    }

    .modal-member:hover {
      background-color: #d1d1d1;
      cursor: pointer;
    }
  }

  .modal-footer {
    border-top: none;
    margin-top: 25px;
    padding: 0;
    position: absolute;
    bottom: 0;
    display: flex;
    justify-content: center;
    width: 100%;
  }
}
</style>
